import { PropsWithChildren, useMemo } from 'react';

import { useReactiveVar } from '@apollo/client';
import {
  getAlgoliaIndexName,
  searchClient,
  algoliaRefreshCacheVar,
} from '@scorenco/core';
import { InstantSearch } from 'react-instantsearch-dom';

import { AlgoliaConfigure } from './AlgoliaConfigure';
import { AlgoliaContext, useInitializeContext } from './AlgoliaContext';

export type AlgoliaProps = PropsWithChildren<{
  indexName: string;
  useCountry?: boolean;
  hitsPerPage?: number;
  clearCacheOnMount?: boolean;
  clubSecuredApiKey?: string;
}>;

export const Algolia = ({
  indexName,
  useCountry,
  hitsPerPage,
  clearCacheOnMount,
  children,
  clubSecuredApiKey = '',
  ...rest
}: AlgoliaProps) => {
  const refresh = useReactiveVar(algoliaRefreshCacheVar);
  const providerValue = useInitializeContext({ clearCacheOnMount });

  const algoliaClient = useMemo(
    () => searchClient(clubSecuredApiKey),
    [clubSecuredApiKey]
  );

  return (
    <AlgoliaContext.Provider value={providerValue}>
      <InstantSearch
        indexName={getAlgoliaIndexName(indexName, useCountry)}
        searchClient={algoliaClient}
        refresh={refresh}
        {...rest}
      >
        <>
          <AlgoliaConfigure hitsPerPage={hitsPerPage} />
          {children}
        </>
      </InstantSearch>
    </AlgoliaContext.Provider>
  );
};
